import { useMutation } from 'query';
import { useUpdateCommentLike } from '../../hooks';
import { likeObject } from '../../services';

export type UseCommentLikeActionType = {
  contentObjectId: string;
  id: string;
};

export const useCommentLikeObjectMutation = () => {
  const updateComments = useUpdateCommentLike({ action: 'like' });

  return useMutation<unknown, UseCommentLikeActionType>({
    mutationFn: async ({ id }) => likeObject({ routeParams: { id } }),
    onSuccess(_, params) {
      updateComments(params);
    },
  });
};
